import {i18n} from '@/plugins/i18n'

export default [
    {
        field: 'index',
        title: '#',
        sortable: true,
        width: 20,
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'customer_detail.Name',
        title: i18n.t('pos.account_owner_name'),
        sortable: false,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'customer_detail.customer_code',
        title: i18n.t('pos.customer_code'),
        sortable: false,
        width: 80,
        textAlign: 'center',
        template: (row) => {
            let customer_type = row.customer_detail.customer_type_id
            let customer_code =      null
            if (customer_type == 1327) {
                customer_code = row.customer_detail.national_code
            } else {
                customer_code = row.customer_detail.company_code
            }
            return '<div> ' + customer_code + '</div>'
        }
    },
    {
        field: 'sheba_number',
        title: i18n.t('label.sheba_number'),
        sortable: false,
        width: 185,
        textAlign: 'center',
    },
    {
        field: 'sharing_percent',
        title: i18n.t('allotment.percent'),
        sortable: true,
        width: 60,
        textAlign: 'center',
    }
]